import axiosInstance from '../api.service';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "ProjectForm/";

const getProjectFormById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProjectFormById?id=' + id, constants.REQUIRE_INTERCEPTORS)

const getProjectFormsByProjectId = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetProjectFormsByProjectId?projectId=' + id, constants.REQUIRE_INTERCEPTORS);

const saveProjectForm = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveProjectForm', model, constants.REQUIRE_INTERCEPTORS);

const deleteProjectForm = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteProjectForm?id=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getProjectFormById,
    saveProjectForm,
    deleteProjectForm,
    getProjectFormsByProjectId
}